export enum InterventionType {
  SideEffect = 'SideEffect',
  Adherence = 'Adherence',
}
